import React, { useEffect, useRef } from "react";

function ArtPlacerWidget(props) {
  const {
    gallery = "49111",
    artworkUrl,
    height,
    title,
    size,
    price,
    artist,
  } = props;

  const anchorRef = useRef(null);

  useEffect(() => {
    const scriptSrc = "https://widget.artplacer.com/js/script.js";
    let existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

    // Step 1: Load script if not already loaded
    if (!existingScript) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      script.onload = () => {
        console.log("✅ ArtPlacer script loaded");
        insertWidget();
      };
      document.body.appendChild(script);
    } else {
      // Script already there — insert widget directly or after load
      if (window.ArtPlacer) {
        insertWidget();
      } else {
        existingScript.addEventListener("load", insertWidget);
      }
    }

    // Step 2: Insert the widget
    function insertWidget() {
      if (!window.ArtPlacer || !artworkUrl) return;

      // Remove old buttons to avoid duplicates
      const prevButtons = document.querySelectorAll(".artplacer-button");
      prevButtons.forEach((b) => b.remove());

      try {
        window.ArtPlacer.insert({
          gallery: gallery,
          default_style: "true",
          button_width: "auto",
          unit: "in",
          type: "3",
          artwork_url: artworkUrl,
          height: height,
          title: title,
          size: size,
          price: price,
          artist: artist,
          after: `#${anchorRef.current.id}`,
        });
      } catch (err) {
        console.error("❌ ArtPlacer insert failed:", err);
      }
    }

    // Step 3: Clean up on unmount
    return () => {
      const prevButtons = document.querySelectorAll(".artplacer-button");
      prevButtons.forEach((b) => b.remove());
    };
  }, [gallery, artworkUrl, height, title, size, price, artist]);

  return (
    <div style={{ marginTop: "21px" }}>
      {/* This is the anchor; widget gets inserted *after* this element */}
      <div
        id={`artplacer-anchor-${gallery}-${Math.floor(Math.random() * 100000)}`}
        ref={anchorRef}
        style={{ display: "inline-block" }}
      ></div>
    </div>
  );
}

export default ArtPlacerWidget;
